module.exports = {
  '@primary-color': '#af3947',
  '@link-color': '#ed939f',
  '@redMain': '#af3947',
  '@greyDark': '#454545',
};
